import { render, staticRenderFns } from "./XPDialog.vue?vue&type=template&id=71169cc0&"
import script from "./XPDialog.vue?vue&type=script&lang=js&"
export * from "./XPDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports